import { useEffect, useState } from 'react';

const secondsUntil = (deadline) => Math.max(0, Math.ceil(((deadline || 0) - Date.now()) / 1000));

// Segundos restantes até o instante deadline (ms); zero quando vazio ou já passou.
export default function useCountdown(deadline) {
  const [seconds, setSeconds] = useState(() => secondsUntil(deadline));

  useEffect(() => {
    setSeconds(secondsUntil(deadline));
    if (secondsUntil(deadline) === 0) return undefined;

    const id = setInterval(() => {
      const left = secondsUntil(deadline);
      setSeconds(left);
      if (left === 0) clearInterval(id);
    }, 1000);
    return () => clearInterval(id);
  }, [deadline]);

  return seconds;
}
